<template>
  <q-chip :dark="computedDark" :color="computedColor" :icon="computedIcon" :square="square" :outline="outline" :class="{ blink: blink }">
    <div class="ellipsis">
      {{message}}
      <q-tooltip>{{ message }}</q-tooltip>
    </div>
    <div class="buttons">
      <slot name="buttons" />
    </div>
  </q-chip>
</template>

<script>
import { PromptLevel } from '@/lib/enums'
import utils from '@/lib/utils'
import { colors } from 'quasar'
export default {
  props: {
    square: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number
    },
    icon: String,
    color: String,
    dark: Boolean,
    outline: Boolean,
    blink: Boolean,
    message: String
  },
  computed: {
    computedIcon () {
      return this.icon ?? PromptLevel.getItemIcon(this.level)
    },
    computedColor () {
      return this.color ?? PromptLevel.getItemColor(this.level)
    },
    computedDark () {
      return this.dark ?? (colors.brightness(utils.computeColorValue(this.computedColor)) < 128)
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons > * {
  margin-left: 10px;
}
</style>
